import { BrowserRouter, Link, Routes, Route } from 'react-router-dom';
import { About, Privacy, Hampton, HamptonNews, Sebago, Home, Schedule, Contact } from '.';

export const NavHeader = () => {
    return (
        <BrowserRouter>
            <div class="container">
                <img alt="Catamaran Racing Association Northern New England" src="/images/CranneLogo.svg" height="64" />
            </div>
            <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-primary text-light border-bottom box-shadow mb-3">
                <div class="container">
                    <Link class="navbar-brand text-light" to="/">CRANNE</Link>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target=".navbar-collapse"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="navbar-collapse collapse d-sm-inline-flex justify-content-between">
                        <div class="navbar-nav flex-grow-1">
                            <Link class="nav-link text-light" to="/">Home</Link>
                            <Link class="nav-link text-light" to="/schedule">Schedule</Link>
                            <Link class="nav-link text-light" to="/contact">Contact</Link>
                            <Link class="nav-link text-light" to="/about">About</Link>
                            <Link class="nav-link text-light" to="/privacy">Privacy</Link>
                        </div>
                    </div>
                </div>
            </nav>

            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/schedule" element={<Schedule />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/about" element={<About />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/hampton" element={<Hampton />} />
                <Route path="/sebago" element={<Sebago />} />
                <Route path="/hampton/news" element={<HamptonNews />} />
            </Routes>
        </BrowserRouter>
    );
}

export default NavHeader;